import styled from 'styled-components';

export const InputText = styled.input`
    height: ${props => props.height? props.height.toString(): 25}px;
    
    padding: 2px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 3px;
    display: inline-block;
    @media(min-width: 800px){
        width: ${props => props.ancho? props.ancho: 100}%;
        margin-left: ${props => props.margen_izq? props.margen_izq: 0}px;
    }    
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:0}px;
    margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    text-transform: ${props => props.mayusculas? 'uppercase': 'none'};
`;
